/* eslint-disable react/prop-types */
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { OptionGroup } from "interfaces/mappingInterfaces"
import { OptionProps, components } from "react-select"

const incrementNestedId = (id: string): string => `${id}-inner-${Math.floor(Math.random() * 100000)}`

const handleHeaderClick = (id?: string) => {
  const node = document.querySelector(`#${id}`)?.parentElement?.nextElementSibling
  if (!node) return

  const classes = node.classList
  if (classes.contains("collapsed")) {
    node.classList.remove("collapsed")
  } else {
    node.classList.add("collapsed")
  }
}

const RenderGroupLabel = ({
  label,
  value,
  nestedOptions,
  props,
}: {
  label: string
  value: string
  nestedOptions?: OptionGroup[]
  props: OptionProps<OptionGroup>
}): React.ReactElement => {
  const { innerProps, selectOption } = props

  const parentInnerProps = JSON.parse(JSON.stringify(innerProps))
  parentInnerProps.onClick = () => selectOption({ label, value: value || label })

  return (
    <div className="flex items-center font-bold text-sky-600 select-group-label" style={{ paddingLeft: 10 }}>
      {nestedOptions?.length ? (
        <FontAwesomeIcon
          icon={faPlus}
          color="var(--interactive-01)"
          size="xs"
          className="cursor-pointer pl-2"
          onClick={() => handleHeaderClick(props?.innerProps?.id)}
        />
      ) : (
        <div className="w-5" />
      )}

      <components.Option {...props} innerProps={parentInnerProps} className="!flex !items-center !justify-between">
        <span className="capitalize">{label}</span>
        <span className="text-sm">{nestedOptions?.length || ""}</span>
      </components.Option>
    </div>
  )
}

const renderNestedOption = (
  props: OptionProps<OptionGroup>,
  label: string,
  value: string,
  nestedOptions: OptionGroup[],
): React.ReactElement => {
  const { innerProps, selectOption } = props

  return (
    <>
      <RenderGroupLabel label={label} nestedOptions={nestedOptions} props={props} value={value} />

      <div className="collapsed pl-3">
        {nestedOptions.map(nestedOption => {
          const nestedInnerProps = JSON.parse(JSON.stringify(innerProps))
          nestedInnerProps.id = incrementNestedId(nestedInnerProps.id)
          nestedInnerProps.onClick = () => selectOption(nestedOption)

          if (nestedOption.children?.length) {
            return renderNestedOption(
              { ...props, innerProps: nestedInnerProps },
              nestedOption.label,
              nestedOption.value,
              nestedOption.children,
            )
          }

          return (
            <div key={nestedOption.value} style={{ paddingLeft: 10 }}>
              <components.Option {...props} innerProps={nestedInnerProps} className="!pl-8">
                {nestedOption.label}
              </components.Option>
            </div>
          )
        })}
      </div>
    </>
  )
}

const CustomOption = (props: OptionProps<OptionGroup>): React.ReactElement => {
  const { data } = props
  const label = data.label
  const value = data.value
  const nestedOptions = data.children

  if (nestedOptions?.length) {
    return renderNestedOption(props, label, value, nestedOptions)
  }

  return <RenderGroupLabel label={label} props={props} value={value} />
}

export default CustomOption
